import React from 'react';
import SpecList from './SpecList';
import './ModelSpecListPanel.css';

/**
 * 모델별 사양 리스트 — 메인 리스트와 동일한 행·접기 UI, 데이터만 `products_model_spec`으로 분리.
 */
const ModelSpecListPanel = (props) => (
    <div className="model-spec-list-page-wrap">
        <p className="model-spec-list-note">
            메인 리스트와 저장소가 분리되어 있습니다. 검색·필터는 이 목록에만 적용됩니다.
        </p>
        <SpecList
            {...props}
            listVariant="modelSpecList"
            listSummaryModelNameOnly={false}
            omitSectionHeading={false}
        />
    </div>
);

export default ModelSpecListPanel;
